export class CampaignRewardModel {
    id: number;
    name: string;
    description: string;
}